import React, { useEffect, useState } from "react";

interface hoursMinSecType {
  hours: number;
  minutes: number;
  seconds: number;
}

interface formatType {
  hours: boolean;
  minutes: boolean;
  seconds: boolean;
}

type CountDownTimerPropsType = {
  onlySeconds?: boolean;
  hoursMinSec: hoursMinSecType;
  format: formatType;
  cbFunc?: Function;
};
function CountDownTimer({
  onlySeconds = false,
  hoursMinSec,
  format,
  cbFunc = () => {},
}: CountDownTimerPropsType) {
  const [isTimerStop, setIsTimerStop] = useState(false);
  const { hours = 0, minutes = 3, seconds = 60 } = hoursMinSec;
  const [[hrs, mins, secs], setTime] = useState([hours, minutes, seconds]);

  useEffect(() => {
    console.log("seconds--->", seconds);
  }, [seconds]);

  useEffect(() => {
    if (hrs == 0 && mins == 0 && secs == 0) {
      cbFunc();
    }
  }, [cbFunc, hrs, mins, secs]);

  const tick = () => {
    if (hrs === 0 && mins === 0 && secs === 0) reset();
    else if (mins === 0 && secs === 0) {
      setTime([hrs - 1, 59, 59]);
    } else if (secs === 0) {
      setTime([hrs, mins - 1, 59]);
    } else {
      setTime([hrs, mins, secs - 1]);
    }
  };

  const reset = () => {
    setIsTimerStop(true);
  };

  useEffect(() => {
    const timerId = setInterval(() => tick(), 1000);
    if (isTimerStop) {
      return () => clearInterval(timerId);
    }
    return () => clearInterval(timerId);
  });
  console.log("secs", secs, secs.toString().padStart(2, "0"));
  return (
    <span style={{ color: "var(--LightTheme-Primary)" }}>
      {onlySeconds ? (
        format.seconds && `${secs.toString().padStart(1, "0")}`
      ) : (
        <>
          {format.hours && `${hrs.toString().padStart(2, "0")}:`}
          {format.minutes && `${mins.toString().padStart(2, "0")}:`}
          {format.seconds && `${secs.toString().padStart(2, "0")}`}
        </>
      )}
    </span>
  );
}

export default CountDownTimer;
